<!-- Traditional checkbox with checkmark -->
<label class="relative flex h-full w-full cursor-pointer items-center justify-center">
  <input
    type="checkbox"
    class="peer sr-only"
    [checked]="value()"
    [indeterminate]="indeterminate()"
    (change)="onInput()"
    (blur)="onTouched()" />

  <!-- Custom checkbox appearance -->
  <div
    [class]="
      'duration-base relative h-5 w-5 rounded border-2 transition-all ' +
      'peer-focus:ring-accent-focus/40 peer-focus:ring-4 peer-focus:outline-none ' +
      (value() ? 'border-accent-main bg-accent-main' : 'border-default bg-surface')
    ">
    <!-- Checkmark icon -->
    @if (value()) {
      <svg
        class="absolute inset-0 h-full w-full p-0.5 text-white"
        viewBox="0 0 20 20"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round">
        <polyline points="4,10 8,14 16,6"></polyline>
      </svg>
    }

    <!-- Indeterminate state (dash) -->
    @if (indeterminate() && !value()) {
      <svg
        class="absolute inset-0 h-full w-full p-1.5 text-white"
        viewBox="0 0 20 20"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round">
        <line x1="4" y1="10" x2="16" y2="10"></line>
      </svg>
    }
  </div>
</label>
